export class PwaUpdate {
  waiting:ServiceWorker|null=null;
  private requested=false;
  constructor(){navigator.serviceWorker?.addEventListener('controllerchange',()=>{if(this.requested)location.reload();});}
  apply(safe:boolean):boolean{
    if(!safe||!this.waiting)return false;this.requested=true;this.waiting.postMessage({type:'ACTIVATE'});return true;
  }
}
